import { ajaxCall, formRequestData } from './ajaxService';
import constants from './../common/constants';

const loginUrl = `${constants.ajax.baseUrl}/api/Users/authenticate`;
const validateTokenUrl = `${constants.ajax.baseUrl}/api/Users/validate`;
const logoutUrl = `${constants.ajax.baseUrl}/api/Users/logout`;
const refreshTokenUrl = `${constants.ajax.baseUrl}/api/Users/refresh-jwt`;

const ajaxLogin = (userData: any) => new Promise((res, rej) => {
    ajaxCall(loginUrl, formRequestData(constants.ajax.methods.post, false, constants.ajax.credentials.include, userData))
        .then(res)
        .catch(rej);
})

const ajaxValidateToken = () => new Promise((res, rej) => {
    ajaxCall(validateTokenUrl, formRequestData(constants.ajax.methods.get, true))
        .then(res)
        .catch(rej);
});

const ajaxLogout = () => new Promise((res, rej) => {
    ajaxCall(logoutUrl, formRequestData(constants.ajax.methods.get, true))
        .then(res)
        .catch(rej);

});
const ajaxRefreshToken = () => new Promise((res, rej) => {
    ajaxCall(refreshTokenUrl, formRequestData(constants.ajax.methods.get, true, constants.ajax.credentials.include))
        .then(res)
        .catch(rej);
});

export {
    ajaxLogin,
    ajaxValidateToken,
    ajaxLogout,
    ajaxRefreshToken
};